import config from "../../../boot/config";
import http from "../../../boot/http.js";
import { Interval, Point } from "../types";
import * as utils from "../../../utils";
import { socket, actions } from "./redux";
import moment from "moment";

const UPDATE_INTERVAL = 2000;
const route = "point/"

export default class {
	static _interval = new Interval(UPDATE_INTERVAL);

	static Start() {
		this._interval.Start(this.request.bind(this));
		//call immediately
		this.request();
	}

	static Cleanup() {
		this._interval.End();
	}

	static GetLive(pointLiveRequests) {
        
        let url = `${config.baseUrl + route}/GetLive`;
		let fakeVal1 = Math.floor(Math.random() * 10);
		let fakeFrom = moment().format("YYYY-MM-DTHH:mm:ss.SSSSSSS+08:00");
		let fakeTo = moment().format("YYYY-MM-DTHH:mm:ss.SSSSSSS+08:00");
		let fakeData1 = {
			pointId: "Fake",
			currentValue: fakeVal1,
			history: {
				from: fakeFrom,
				to: fakeTo,
				values: [
					{
						value: fakeVal1,
						timestamp: fakeTo,
					}
				],
			},
		}; 

		let fakeVal2 = Math.ceil(Math.random() * 4 + 8);
		let fakeData2 = {
			pointId: "Fake2",
			currentValue: fakeVal2,
			history: {
				from: fakeFrom,
				to: fakeTo,
				values: [
					{
						value: fakeVal2,
						timestamp: fakeTo,
					}
				],
			},
		};

		return [fakeData1, fakeData2];

        return http({url, method: 'POST'})
            .then((data) => data)
            .catch((error) => error)
    } 

	/**
	 *
	 * @param {Point} point
	 */
	static RegisterPoint(point) {
		socket.dispatch(actions.registerPoint(point));
	}

	static DeregisterPoint(point){
		socket.dispatch(actions.deregisterPoint(point));
	}

	static RegisterProcessor(processor) {
		socket.dispatch(actions.registerProcessor(processor));
	}
	static DeleteProcessor(processorId) {
		socket.dispatch(actions.deleteProcessor(processorId));
	}

	static request() {
		socket.dispatch(actions.makeRequest());
	}
}



// WEBPACK FOOTER //
// ./src/services/Live/LiveFeed/livefeed.js